import { render } from "./DockerAfterInstallation.vue?vue&type=template&id=68db37cc"
import script from "./DockerAfterInstallation.vue?vue&type=script&lang=js"
export * from "./DockerAfterInstallation.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__